import { API } from '@/http-common.js';
import http_functions from './http_functions.js';

export const downloadAttestationParticipant = (
    attestationId: number | undefined
) => {
    http_functions.methods.downloadFile(
        `/participant/attestation/${attestationId}`
    );
};

export const downloadSupportFormation = async (row) => {
    const isElearning = row.type && row.type.id === 2;

    const participants = isElearning
        ? 'elearningParticipantId'
        : 'sessionParticipantId';
    const parcoursProduitIdParam = row.parcoursProduitId
        ? `&parcoursProduitId=${row.parcoursProduitId}`
        : '';

    const params = `?${participants}=${row.participantId}${row.sessionId ? `&sessionId=${row.sessionId}` : ''}${parcoursProduitIdParam}`;

    const response = await API.get(
        `/participant/v2/${row.id}/support/file/disponibilite${params}`
    );

    if (
        response &&
        response.data &&
        response.data.message === 'Appreciation requise'
    ) {
        return { appreciationRequired: true };
    } else {
        if (row.url) {
            http_functions.methods.downloadFile(
                `${row.url}${params}`,
                row.nomUrl
            );
        } else {
            window.open(row.lien, '_blank');
        }
        return { appreciationRequired: false };
    }
};

export const downloadDocument = (row) => {
    http_functions.methods.downloadFile(`${row.url}`, row.nomUrl);
};

export const downloadDocumentsZip = (sessionParticipantId: number) => {
    http_functions.methods.downloadFile(
        `participant/v2/formation/${sessionParticipantId}/documents`,
        'Documents.zip'
    );
};
export const downloadSupportsZip = (commandeId: number, reference: number) => {
    http_functions.methods.downloadFile(
        `participant/v2/commande/${commandeId}/formation/${reference}/supports`,
        'Supports.zip'
    );
};
